import React from 'react';
import { AlertTriangle, X, Eye, ArrowLeft } from 'lucide-react';
import { useViewAs } from '../../context/ViewAsContext';

const ViewAsIndicator = () => {
  const { 
    isViewingAs, 
    viewingRole, 
    user,
    getRoleLabel, 
    exitViewAs 
  } = useViewAs();

  if (!isViewingAs) {
    return null;
  }

  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-5 w-5 text-amber-400" />
          </div>
          <div className="ml-3">
            <div className="flex items-center space-x-2">
              <Eye className="h-4 w-4 text-amber-600" />
              <p className="text-sm font-medium text-amber-800">
                Viewing as: <span className="font-semibold">{getRoleLabel(viewingRole)}</span>
              </p>
            </div>
            <p className="text-xs text-amber-700 mt-1">
              You are seeing the system from the perspective of a {getRoleLabel(viewingRole).toLowerCase()}. 
              Your actual role is {getRoleLabel(user?.role)}.
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2">
          <button
            onClick={exitViewAs}
            className="inline-flex items-center px-3 py-1.5 border border-amber-300 text-xs font-medium rounded-md text-amber-700 bg-amber-100 hover:bg-amber-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors"
          >
            <ArrowLeft className="h-3 w-3 mr-1" />
            Exit View As
          </button>
          
          <button
            onClick={exitViewAs}
            className="inline-flex items-center justify-center w-6 h-6 text-amber-400 hover:text-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 rounded-full"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewAsIndicator;
